import axios from 'axios';
import { get } from 'lodash-es';

export const getAllIntegrations = async () => {
  try {
    const response = await axios.get('/integrations/all');
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error getting all integrations : ${error?.message}`, { cause: error });
  }
};

export const getReturnRabbitKey = () => {
  return axios.get('returnrabbit');
};

export const createReturnRabbitKey = () => {
  return axios.post('returnrabbit');
};

export const getAllWebhooks = async () => {
  try {
    const response = await axios.get('/webhooks');
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error getting all webHooks: ${error?.message}`, { cause: error });
  }
};

export const addWebhook = async (data) => {
  try {
    const response = await axios.post('/webhooks', data);
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error adding a webHook: ${error?.message}`, { cause: error });
  }
};

export const editWebhook = async (data) => {
  try {
    const response = await axios.put('/webhooks', data);
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error editing a webHook: ${error?.message}`, { cause: error });
  }
};

export const deleteWebhook = async (webHookId) => {
  try {
    const response = await axios.delete(`/webhooks/${webHookId}`);
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error deleting a webhook : ${error?.message}`, { cause: error });
  }
};

export const getShipperHQConnections = () => {
  return axios.get('/shipperhqconnection');
};

export const createShipperHQConnection = (payload) => {
  return axios.post('/shipperhqconnection', payload);
};

export const updateShipperHQConnection = (payload) => {
  return axios.put('/shipperhqconnection', payload);
};

export const deleteShipperHQConnection = (storeGuid) => {
  return axios.delete(`/shipperhqconnection/${storeGuid}`);
};

export const getShipperHQConnectedStoreGuids = () => {
  return getShipperHQConnections()
    .then((res) => {
      if (res.data) {
        return res.data.map((config) => config.storeGuid);
      }
    })
    .catch((err) => {
      throw new Error(`Error getting ShipperHQ Connection: ${err}`, { cause: err });
    });
};

export const getGoogleConnections = () => {
  return axios.get('/google');
};

export const setGoogleConnections = async (payload) => {
  try {
    const response = await axios.post('/google', payload);
    const result = get(response, 'data') || [];
    return result;
  } catch (error) {
    throw new Error(`Error updating Google Stores : ${error?.message}`, { cause: error });
  }
};

export const getOauthIntegrations = (oauthIntegrationId) => {
  return axios.get(`/integrations/oauth?oauthIntegrationId=${oauthIntegrationId}`);
};

export const getKlaviyoOAuthConnectUrl = async () => {
  try {
    const response = await axios.get('/oauth/connect/Klaviyo');
    return get(response, 'data.RedirectUrl');
  } catch (error) {
    throw new Error(`Error getting Klaviyo OAuth connect URL: ${error?.message}`, { cause: error });
  }
};

export const revokeOauthIntegration = (id) => {
  return axios.delete(`/integrations/oauth/revoke/${id}`);
};
